"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Modal_1 = require("../context/Modal");
function useModal() {
    var _a = React.useContext(Modal_1.ModalContext), spawnModal = _a.spawnModal, despawnModal = _a.despawnModal, despawnAllModals = _a.despawnAllModals, data = _a.data;
    return {
        spawnModal: spawnModal,
        despawnModal: despawnModal,
        despawnAllModals: despawnAllModals,
        data: data,
    };
}
exports.default = useModal;
//# sourceMappingURL=useModal.js.map